import { DataTableCollapsibleRow, Dialog, FormSectionHeader, Heading, Loader } from "@/components";
import useTraceabilityReport from "./useTraceabilityReport";
import { Card, CardContent, CardHeader, Input } from "@/components/ui";
import { cn } from "@/lib/utils";
import { Search } from "lucide-react";
import { InfoDialog } from "./InfoDialog";

const TraceabilityReport = () => {
  const {breadcrumbData, isLoadingReportData, summaryCards, columns, subColumns, currentFinanceYear,
    tableData, onRowExpanded, globalFilter, setGlobalFilter, level2Columns, openGroupGlDialog,
    setOpenGroupGlDialog, groupGlList, openInfoDialog, setOpenInfoDialog, selectedGlId
  } = useTraceabilityReport();

  return (
    <div className="p-4">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={<span>Traceability Report <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>} breadcrumbData={breadcrumbData} />
      </div>

      {isLoadingReportData ? <Loader /> : 
        <>
          <Card className="mb-6">
            <CardContent>
              <span className="font-medium text-[14px] text-gray-400">Full lineage from the originating journal entry line to every final receiver, with per-source-line balancing so no value is lost or double-counted. Critical for audit.</span>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-[20px] mt-5">
                {summaryCards?.map((data: any) => {
                  return (
                    <Card className={cn("shadow-none", data?.className ? data?.className : data?.isBalanced ? "bg-green-50" : "bg-red-50")} key={data?.id}>
                      <CardContent className="font-medium text-gray-400 text-[14px] flex flex-col items-center justify-center">
                        <label>{data?.title}</label>
                        <span className="text-[20px] text-black">{data?.amt || data?.text || ""}</span>
                        <label className="text-center">{data?.desc}</label>
                      </CardContent>
                    </Card>
                  )
                })}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-col md:flex-row md:items-center md:justify-between">
              <FormSectionHeader>Full Lineage</FormSectionHeader>
              <div>
                <Input
                  type="text"
                  placeholder="Search by Doc Number, sender, or receiver..."
                  value={globalFilter ?? ""}
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  className="w-full sm:w-72 bg-white h-[40px]"
                  startIcon={<Search className="w-4 h-4" />}
                />
              </div>
            </CardHeader>
            <CardContent>
              <DataTableCollapsibleRow
                containerClassName="shadow-none"
                columns={columns}
                nestedColumns={[subColumns, level2Columns]}
                data={tableData || []}
                onExpand={onRowExpanded}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                separateExpandColumn
              />
            </CardContent>
          </Card>
        </>
      }

      <Dialog open={openGroupGlDialog} setOpen={setOpenGroupGlDialog}
        title={
          <div className="text-2xl font-bold text-primary">
            {"View Group GL(s)"}
            <div className="h-1 w-[30%] bg-primary rounded-full" />
          </div>
        }
      >
        <div className="flex flex-col">
          {groupGlList?.length ? groupGlList?.map((data: any) => {
              return (
                <span>{data?.glAccountNumber} - {data?.glName}</span>
              )
            }) : <span>No Data Found</span>
          }
        </div>
      </Dialog>
      {openInfoDialog && <InfoDialog open={openInfoDialog} setOpen={setOpenInfoDialog} glMasterId={selectedGlId} />}
    </div>
  )
}

export default TraceabilityReport;